import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { orgsAPI } from '../services/login'

function UseOrganization() {
  const profile = useSelector((state) => state.loginReducer.profile)
  const [data, setData] = useState([])
  
  useEffect(() => {
    const getOrganization = async () => {
     
      const result = await orgsAPI()
      if (!result) return
      const newData = result.result.map((d, i) => {
        return { value: d.id, label: d.org }
      })
      setData(newData)
    }
    getOrganization()
  }, [])


  return data
}

export default UseOrganization
